<app-drop-down-single-con-id [data]="estados"
                             (elementoSeleccionado)="actualizaFiltroEstado($event)"
                             [valorPreSeleccionado]="estadoSeleccionado"
                             [width]="'200px'"
                             [height]="'30px'"></app-drop-down-single-con-id>

